import type { JSX } from 'react';

import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material';

type ChildType = JSX.Element | string;

interface Props {
  readonly activeTab: string;
  readonly children: ChildType | readonly ChildType[];
  readonly sx?: SxProps<Theme>;
  readonly tabId: string;
  readonly value: string;
}

export const TabPanel = ({
  activeTab,
  children,
  sx,
  tabId,
  value,
  ...otherProps
}: Readonly<Props>) => (
  <Box
    aria-labelledby={tabId}
    hidden={value !== activeTab}
    id={`${tabId}-panel`}
    role="tabpanel"
    sx={sx}
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...otherProps}
  >
    {value === activeTab && children}
  </Box>
);
